<template lang="pug">
div
  div#header
    div.title
      h2.title_item {{ $t('strings.project_flow') }}
      img.icon(src="@/assets/building.png")
    div.button_container
      button.btn_download_pdf(v-if="project.purchase_order != null" @click="downloadPurchaseOrder(project.file_public_url)")
        img.icon(src="@/assets/pdf.svg" style="padding-top: 0.6rem;")
        span.download_text &nbsp; {{ $t('projects_dashboard.download_pdf') }}
  div.project_statistics
    div.main_statistic(style="padding-bottom: 2rem;")
      div.side_color(style="background-color: #e0e0e0")
      div(style="padding-left: 3rem;")
        img(src="@/assets/crane.png")
        strong.project_name {{ project.name}}
        span.project_customer {{ project.customer.name }}
        span.location {{ project.location }},
        nbsp
        span.location {{ project.country}}
        span.project_date {{ project.created_at | moment("DD MMMM YYYY") }}
        span.initial_amount(style="margin-top: 0.5rem;") 💵 {{ $t('projects_dashboard.initial_amount') }}:
        span.initial_amount {{ project.price | currency }}
    div.secondary_statistic
      div.statistic_row
        div.statistic
          div.side_color(style="background-color: #049856")
          span.statistic_text {{ $t('projects_dashboard.income')}}
          strong.statistic_number {{ project.income | currency }}
        div.statistic
          div.side_color(style="background-color: #bb8700")
          span.statistic_text  {{ $t('projects_dashboard.expenses')}}
          strong.statistic_number {{ project.sale_cost | currency }}
        div.statistic
          div.side_color(style="background-color: #a5170f")
          span.statistic_text {{ $t('projects_dashboard.utility')}}
          strong.statistic_number {{ project.utility | currency }}
      div.statistic_row
        div.statistic
          div.side_color(style="background-color: #6dfea8")
          span.statistic_text {{ $t('projects_dashboard.invoiced')}}
          strong.statistic_number {{ invoiced | currency }}
        div.statistic
          div.side_color(style="background-color: #fedf89")
          span.statistic_text {{ $t('projects_dashboard.unbilled')}}
          strong.statistic_number {{ project.unbilled | currency }}
        div.statistic
          div.side_color(style="background-color: #ff5d54")
          span.statistic_text {{ $t('projects_dashboard.invoiced_percentage')}}
          strong.statistic_number {{ invoicedPercentage }} %
  br
  h2 {{ $t('projects_dashboard.income') }} / {{ $t('projects_dashboard.expenses') }}
  br
  ProjectConcepts(@updateStatistics="updateView")
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Projects')
export default {
  components: {
    ProjectConcepts: () => import('@/components/dashboard/projects/ProjectConcepts.vue')
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    currentPage: 1,
    date: '',
    columns: ['date', 'concept', 'payment', 'charge', 'status']
  }),
  computed: {
    ...mapGetters([
      'project'
    ]),
    invoiced () {
      return this.project.invoiced_income + this.project.income
    },
    invoicedPercentage () {
      const percentage = (this.invoiced / this.project.sale_amount) * 100
      return parseFloat(percentage).toFixed(2)
    }
  },
  async created () {
    await this.loadRecord({ id: this.$route.params.id })
  },
  methods: {
    ...mapActions([
      'loadRecord',
      'exportPurchaseOrder'
    ]),
    async updateView () {
      setTimeout(async () => {
        await this.loadRecord({ id: this.$route.params.id })
      }, 100)
    },
    filterByStatus (concept) {
      return concept.status === 1
    },
    downloadPurchaseOrder (url) {
      this.exportPurchaseOrder(url)
    }
  }
}
</script>
<style scoped lang="scss">
@import './project_dashboard_structure.css';
#main_statistic {
  padding-left: 2rem;
}
#main_icon {
  width: 4rem;
  height: 4rem;
  padding-right: 1rem;
}
#statistic_row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 1rem;
    margin-top: 1rem;
}
</style>
